import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { accountDetailsEditorActions } from './account-details-editor.actions';
import { map } from 'rxjs/operators';
import {profileApiActions} from "@fitup-monorepo/core/lib/state/profile/profile.actions";

@Injectable()
export class AccountDetailsEditorEffects {
  private readonly actions$ = inject(Actions);

  public updateCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(accountDetailsEditorActions.updateCustomer),
      map(props => profileApiActions.updateCustomer(props))
    )
  );
}
